import { Fragment, useState, useEffect, useRef } from "react";
// import axios from "axios";
import { useTranslation } from 'react-i18next';
// import numeral from 'numeral';

import Backdrop from "../Backdrop/Backdrop";
import MergerInfo from "./MergerInfo";
import MergerFileSelectContents from "./MergerFileSelectContents";
// import CombinerFileEdit from "./CombinerFileEdit";
import ImageConvert from "../ImageConvert/ImageConvert";
import Modal from "../Modal/Modal";

import { useStore } from '../../hook-store/store';
// import { changeImageDimensionSize } from '../../utils/image-util'

// import { BACKEND_URL } from "../../App";

import { marks } from '../../utils/marks';
import "./ImageMerger.css";

export default function MergerInputs(props) {
  const { 
    setCombinedB64String,
    // setCombinerInputFiles,
    inputFiles,
    setInputFiles,
    fileDimensions,
    setFileDimensions,
  } = props;

  const [t] = useTranslation('translation');

  const hiddenFileInput = useRef(null);
  const hiddenFileInput2 = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    // isAuth, 
    gLoading 
  } = store.uiStore;


  const [inputFile, setInputFile] = useState();
  const [inputFile2, setInputFile2] = useState();
  // const [inputFiles, setInputFiles] = useState([]);
  const [selectedFileKind, setSelectedFileKind] = useState('one');

  const [fileDimension, setFileDimension] = useState({
    height: 0,
    width: 0,
  });
  const [fileDimension2, setFileDimension2] = useState({
    height: 0,
    width: 0,
  });
  const [showCombinerInfo, setShowCombinerInfo] = useState(false);
  const [showFileSelectModal, setShowFileSelectModal] = useState(false);
  const [showImageConvert, setShowImageConvert] = useState(false);
  const [editSelectedNo, setEditSelectedNo] = useState(0);
  
  const [isLoading, setIsLoading] = useState(false);

  // console.log(inputFile, inputFile2, inputFiles);

  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);

  useEffect(() => {
    if (inputFile) {
      setInputFiles([inputFile]);
    }
    if (inputFile2) {
      setInputFiles([inputFile2]);
    }
    if (inputFile && inputFile2) {
      setInputFiles([inputFile, inputFile2]);
    }
  },[inputFile, inputFile2]);

  useEffect(() => {
    setFileDimensions([
      fileDimension,
      fileDimension2,
    ]);
  },[fileDimension, fileDimension2]);


  const handleInputClick = (event, inputNum) => {
    if (inputNum === 1) {
      hiddenFileInput.current.click();
    } else {
      hiddenFileInput2.current.click();
    }
  };


  const getImgDimension = (event, inputNum) => {
    // console.log(event, event.target.naturalHeight, event.target.naturalWidth);

    // console.log(event, event.target.naturalHeight, event.target.naturalWidth);
    if (inputNum === 1) {
      if (
        event.target.naturalHeight !== fileDimension.height ||
        event.target.naturalWidth !== fileDimension.width
      ) {
        setFileDimension({
          height: event.target.naturalHeight,
          width: event.target.naturalWidth,
        });
      }
    } else {
      if (
        event.target.naturalHeight !== fileDimension2.height ||
        event.target.naturalWidth !== fileDimension2.width
      ) {
        setFileDimension2({
          height: event.target.naturalHeight,
          width: event.target.naturalWidth,
        });
      }
    }
  };


  let sameTypeErrorMessage = "";
  let fileSizeLimitMessage = "";
  let fileScaleLimitMessage = "";

  let isFileBig = false;
  let isFile2Big = false;


  return (
    <Fragment>
      <section className="mergerSectoin">
        <div className="mergerInfoMark">
          <span
            onClick={() => {
              setShowCombinerInfo(!showCombinerInfo);
            }}
          >
            {t('combiner01', 'info')} {marks.infoCircleMark}
          </span>
        </div>
        {showCombinerInfo && (
          <div>
            <MergerInfo />
          </div>
        )}
      </section>
      <section className="mergerSectoin">
        <div className="mergerInputButtons">
          <button
            //   disabled={gLoading}
            className="btnBase"
            onClick={(event) => {
              handleInputClick(event, 1);
            }}
          >
            {t('combiner02', 'Select image')} 1
          </button>
          <button
            //   disabled={gLoading}
            className="btnBase"
            onClick={(event) => {
              handleInputClick(event, 2);
            }}
          >
            {t('combiner02', 'Select image')} 2
          </button>
          <input
            id="fileinput"
            type="file"
            ref={hiddenFileInput}
            style={{ display: "none" }}
            // onChange={imageInputHandler}
            onChange={(event) => {
              setInputFile(event.target.files[0])
              // blobProcessHandler(event, 1);
            }}
            accept="image/png,image/jpeg"
          />
          <input
            id="fileinput2"
            type="file"
            ref={hiddenFileInput2}
            style={{ display: "none" }}
            // onChange={imageInputHandler}
            onChange={(event) => {
              setInputFile2(event.target.files[0])
              // blobProcessHandler(event, 2);
            }}
            accept="image/png,image/jpeg"
          />
          <span> or </span>
          <button className="btnBase"
            onClick={() => {
              setShowFileSelectModal(true);
            }}
          >
            {marks.cloudDownloadMark} 
            {' '}
            {t('combiner15', 'Use uploaded files')}
          </button>
        </div>
      </section>

      <section className="mergerSectoin">
        <div className="mergerInputImages">
          <div>
            {inputFile && (
              <div>
                <div>{t('combiner03', 'Image')} 1</div>
                <img
                  className="mergerInputImage"
                  // style={{ maxHeight: "100px" }}
                  title={decodeURI(inputFile.name)}
                  src={URL.createObjectURL(inputFile)}
                  alt="for resize"
                  onClick={() => {}}
                  onLoad={(event) => {
                    getImgDimension(event, 1);
                  }}
                />
              </div>
            )}
            {fileDimension.height > 0 && (
              <div 
              // className="combinerImageDeminsions"
              >
                {t('imageMerger07', 'Width')}: {fileDimension.width}
                <br/>
                {t('imageMerger08', 'Height')}: {fileDimension.height}
              </div>
            )}
              {/* {inputFile && (
              <div className="combinerImageDeminsions">
                {numeral(inputFile.size).format('0.0 b')} ({inputFile.type.split('/')[1]})
              </div>
            )} */}

            {/* {(isFileBig || sameTypeErrorMessage) && (
              <button className="btnBase"
                style={{fontSize: "0.9rem"}}
                disabled={isLoading}
                onClick={() => {
                  if (!isLoading) {
                    setEditSelectedNo(1);
                  }
                }}
              >
                resize or change format
              </button>
            )} */}
            
          </div>
          <div>
            {inputFile2 && (
              <div>
                <div>{t('combiner03', 'Image')} 2</div>
                <img
                  className="mergerInputImage"
                  // style={{ maxHeight: "100px" }}
                  title={decodeURI(inputFile2.name)}
                  src={URL.createObjectURL(inputFile2)}
                  alt="for resize"
                  onClick={() => {}}
                  onLoad={(event) => {
                    getImgDimension(event, 2);
                  }}
                />
              </div>
            )}
            {fileDimension2.height > 0 && (
              <div 
              // className="combinerImageDeminsions"
              >
                {t('imageMerger07', 'Width')}: {fileDimension2.width}
                <br/>
                {t('imageMerger08', 'Height')}: {fileDimension2.height}
              </div>
            )}
            {/* {inputFile2 && (
              <div className="combinerImageDeminsions">
                {numeral(inputFile2.size).format('0.0 b')} ({inputFile2.type.split('/')[1]})
              </div>
            )} */}

          {/* {(isFile2Big || sameTypeErrorMessage) && (
            <button className="btnBase"
              style={{fontSize: "0.9rem"}}
              disabled={isLoading}
              onClick={() => {
                if (!isLoading) {
                  setEditSelectedNo(2);
                }
              }}
            >
              resize or change format
            </button>
          )} */}
          </div>
        </div>

        <div className="mergerSectoin">
          <div>
            At Image Editor, 
            {' '}
            {t('combinerInfo05', 'it is possible to crop images for desired image aspect ratio.')}
          </div>
          <div>
            At Image Resizer,
            {' '}
            {t('imageMerger03', 'user can resize images.')}
          </div>
        </div>

        {sameTypeErrorMessage && (
          <div className="mergerSectoin">{sameTypeErrorMessage}</div>
        )}
        {fileSizeLimitMessage && (
          <div className="mergerSectoin">{fileSizeLimitMessage}</div>
        )}
        {fileScaleLimitMessage && (
          <div className="mergerSectoin">{fileScaleLimitMessage}</div>
        )}
      </section>


      {showFileSelectModal && (
        <div>
          <Backdrop 
            onCancel={() => { 
              if (!isLoading) {
                setShowFileSelectModal(false);
              }
            }}
          />
          <Modal
            onClose={() => { 
              if (!isLoading) {
                setShowFileSelectModal(false);
              }
            }}
            hideButtons={true}
          >
            <MergerFileSelectContents 
              selectedFileKind={selectedFileKind}
              setSelectedFileKind={setSelectedFileKind}
              setInputFile={setInputFile}
              setInputFile2={setInputFile2}
              setShowFileSelectModal={setShowFileSelectModal}
              isLoading={isLoading}
            />
          </Modal>
        </div>
      )}


      {showImageConvert && (
          <div>
            <Backdrop 
                onCancel={() => { 
                  if (!isLoading) {
                    setShowImageConvert(false); 
                  }
                }}
              />
              <Modal
                onClose={() => { 
                  if (!isLoading) {
                    setShowImageConvert(false); 
                  }
                }}
              >
              <ImageConvert 
                propConvertFiles={inputFiles}
              />
          </Modal>
        </div>
              
      )}

    </Fragment>
  );
}
